import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/smartphonehoesjesnl.webp';
import screenshot_target from '../../../images/letterfunnel/robertnieuwland.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Robert Nieuwland"
      firstname="Robert"
      companyname="Smartphonehoesjes.nl"
      competition="GSMpunt.nl en Hoesjesdirect.nl"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/robertnieuwland.js